import { RichMarkdownEditor } from "lucy/common-components";
import * as React from "react";
import { Button, Input, Label, Modal } from "uxp/components";
import { IUIPropertyDefinition } from '../common';
import { CommonRichTextProperty, RichTextModal } from "../ui-fields/markdown/Markdown";

export function RichTextProperty(title: string, props: string, showCategoryTitle = false): IUIPropertyDefinition<string> {
	return {
		defaults: props,
		render: (props) => {
			return <CommonRichTextProperty
				value={props.uiProps || ''}
				onChange={s => props.onChange(s)}
				uxpContext={props.uxpContext}
				hideInputBox={true}
				title={title}
			/>

		}
	};
}